@if (payment$ | async; as payment) {
<div class="app-payment-has-been-sent">
  <app-image name="success"></app-image>
  <h3 class="text-center" nz-typography translate data-cy="payment-success-title">
    payment.success.title.{{!payment.scheduled ? payment.operationType : 'isScheduled'}}
  </h3>
  <div class="buttons">
    <button nz-button nzType="primary" nzSize="large" type="button" (click)="done()" translate data-cy="payment-success-button">payment.success.done</button>
  </div>
</div>
}
